import { css } from '@emotion/core'
import { screenSmall } from 'components/utils/screen-sizes'

export const iconCss = css`
  height: 9rem;
`
export const contentCss = css`
  text-align: left;
`

export const unexpectedErrorContentCss = css`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const closeButtonContainer = css`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1000;
`

export const closeButtonWrapper = css`
  position: relative;
`

export const closeBarCss = css`
  position: relative;
  width: 100%;
  margin: 0 auto;
  max-width: 44.875rem;
  height: 5rem;
  background: transparent;

  @media (max-width: ${screenSmall}) {
    height: 2rem;
  }
`

export const closeBarButtonPlacementCss = css`
  position: absolute;
  top: 0.5rem;
  right: 0;
  z-index: 1000;
`

export const deniedPageContentCss = css`
  margin-top: 8rem;
`
